import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_ADMIN_DASHBOARD_COUNT = "admin_dashboard";

const getData = async (props: {
  token: string;
}): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/dashboard`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);

  const item = res.data;
  const data = {
    ...item,
  };

  return data;
};

export const useGetCount = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_ADMIN_DASHBOARD_COUNT],
    () => getData({ token }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
